import React from 'react';
interface Question {
  id: number;
  text: string;
  contextNote: string;
  colorClass: string;
  bgColorClass: string;
  delay: string;
}
const questions: Question[] = [{
  id: 1,
  text: 'What does the rating mean?',
  contextNote: '4.7★ (544) rating',
  colorClass: 'border-rose-500',
  bgColorClass: 'bg-rose-500',
  delay: '0.3s'
}, {
  id: 2,
  text: 'But... is it safe at 11PM?',
  contextNote: 'Walking alone after dark',
  colorClass: 'border-orange-500',
  bgColorClass: 'bg-orange-500',
  delay: '0.4s'
}, {
  id: 3,
  text: 'Is there a hill on the way there?',
  contextNote: '🚶 10 min walking distance',
  colorClass: 'border-teal-500',
  bgColorClass: 'bg-teal-500',
  delay: '0.5s'
}, {
  id: 4,
  text: 'Where should we meet up before?',
  contextNote: 'Street and path conditions',
  colorClass: 'border-violet-500',
  bgColorClass: 'bg-violet-500',
  delay: '0.6s'
}, {
  id: 5,
  text: 'Is this area my vibe?',
  contextNote: 'Mountain View neighborhood',
  colorClass: 'border-blue-500',
  bgColorClass: 'bg-blue-500',
  delay: '0.7s'
}, {
  id: 6,
  text: 'Is it worth the 10 minute walk?',
  contextNote: '🚶 10 min walking distance',
  colorClass: 'border-emerald-500',
  bgColorClass: 'bg-emerald-500',
  delay: '0.8s'
}];
export function AnnotatedScreenSlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-29">
      <div className="flex flex-row w-full h-full min-h-0" data-id="element-30">
        {/* Left Panel — heading only, vertically centered */}
        <div className="flex flex-col justify-center w-[38%] flex-shrink-0 min-h-0 overflow-hidden" style={{
        padding: 'var(--slide-padding)',
        paddingLeft: 'clamp(2rem, 6vw, 6rem)'
      }} data-id="element-31">
          {/* Blue italic label */}
          <p className="italic font-semibold animate-fade-slide" style={{
          color: '#4A90D9',
          fontSize: 'var(--body-size)',
          marginBottom: 'clamp(0.75rem, 1.5vw, 1.25rem)',
          animationDelay: '0.1s'
        }} data-id="element-32">
            This is a data problem.
          </p>

          {/* Bold heading */}
          <h1 className="font-black tracking-tight text-white leading-[0.95] animate-fade-slide" style={{
          fontSize: 'var(--title-size)',
          animationDelay: '0.2s'
        }} data-id="element-33">
            The experience layer doesn't exist.
          </h1>
        </div>

        {/* Right Panel — annotation cards, vertically centered */}
        <div className="flex-1 flex flex-col justify-center min-h-0 overflow-hidden" style={{
        padding: 'var(--slide-padding)',
        paddingRight: 'clamp(2rem, 6vw, 6rem)'
      }} data-id="element-34">
          <div className="flex flex-col" style={{
          gap: 'clamp(0.5rem, 1.2vw, 0.85rem)'
        }} data-id="element-35">
            {questions.map(q => <div key={q.id} className="animate-fade-slide" style={{
            animationDelay: q.delay
          }} data-id="element-36">
                <div className={`
                    rounded-lg border-l-[3px] ${q.colorClass}
                    flex items-center
                  `} style={{
              backgroundColor: 'rgba(255,255,255,0.05)',
              padding: 'clamp(0.65rem, 1.3vw, 1rem) clamp(0.75rem, 1.5vw, 1.25rem)'
            }} data-id="element-37">
                  {/* Number Badge */}
                  <div className={`flex-shrink-0 rounded-full ${q.bgColorClass} flex items-center justify-center`} style={{
                width: 'clamp(24px, 2.8vw, 32px)',
                height: 'clamp(24px, 2.8vw, 32px)',
                marginRight: 'clamp(0.6rem, 1.2vw, 1rem)'
              }} data-id="element-38">
                    <span className="text-white font-bold leading-none" style={{
                  fontSize: 'clamp(11px, 1.3vw, 15px)'
                }} data-id="element-39">
                      {q.id}
                    </span>
                  </div>

                  {/* Question text */}
                  <p className="text-white/90 font-semibold leading-snug" style={{
                fontSize: 'clamp(0.8rem, 1.4vw, 1.1rem)',
                marginRight: 'clamp(0.75rem, 1.5vw, 1.25rem)'
              }} data-id="element-40">
                    {q.text}
                  </p>

                  {/* Separator */}
                  <div className="flex-shrink-0" style={{
                width: '1px',
                height: 'clamp(16px, 2vw, 22px)',
                backgroundColor: 'rgba(255,255,255,0.15)',
                marginRight: 'clamp(0.75rem, 1.5vw, 1.25rem)'
              }} data-id="element-41" />

                  {/* Context note */}
                  <p className="text-white/45 leading-snug whitespace-nowrap" style={{
                fontSize: 'clamp(0.7rem, 1.2vw, 0.95rem)'
              }} data-id="element-42">
                    {q.contextNote}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}